import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import {WindowReload, WindowURLClient, WindowLocationClient, WindowLocation} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {updatevalidations} from './validate'


export default function CLientAccountComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
		}
	}

  const [datenow, setdatenow] = useState('month/day/year ('+moment(new Date()).format('MM/DD/YYYY')+')');
	const [state,setstate] = useState({

		reps_id:'',
		account_type:'',

		first_name:'',
		middle_name:'',
		last_name:'',
		date_birth_options:'1',
		date_birth:'',
		date_birth_text:'',
		citizenship:'',
		citizen_country:'',
		type_id:'',
		id_number:'',
		address1:'',
		address2:'',
		city:'',
		state:'',
		country:'',
		postal_code:'',
		primary_number:'',
		home_number:'',
		cellular_number:'',
		fax:'',
		email:'',
		marital_status:'',
		no_dependents:'',

		joint_first_name:'',
		joint_middle_name:'',
		joint_last_name:'',
		joint_date_birth_options:'1',
		joint_date_birth:'',
		joint_date_birth_text:'',
		joint_citizenship:'',
		joint_citizen_country:'',
		joint_type_id:'',
		joint_id_number:'',
		joint_address1:'',
		joint_address2:'',
		joint_city:'',
		joint_state:'',
		joint_country:'',
		joint_postal_code:'',
		joint_primary_number:'',
		joint_home_number:'',
		joint_cellular_number:'',
		joint_fax:'',
		joint_email:'',
		joint_marital_status:'',
		joint_no_dependents:'',

		years_stock:'',
		years_options:'',
		years_mutual:'',
		years_futures:'',
		years_forex:'',
		ave_stock:'',
		ave_options:'',
		ave_mutual:'',
		ave_futures:'',
		ave_forex:'',
		rate_stock:'',
		rate_options:'',
		rate_mutual:'',
		rate_futures:'',
		rate_forex:'',
		finance_annual:'',
		finance_marginal:'',
		finance_totalnet:'',
		finance_liquidnet:'',
		finance_sourceincome:'',
		number_contracts:'',
		name_contracts:'',
		finance_amount:'',
		finance_fund:'',
		specify_finance_liquidnet:'',
		specify_finance_totalnet:'',
		specify_finance_annual:'',


	});

	function handleSubmitForm(values, props){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);


		let value = {

			reps_id:values.reps_id,
			account_type:values.account_type,

			first_name:values.first_name,
			middle_name:values.middle_name,
			last_name:values.last_name,
			date_birth_options:values.date_birth_options,
			date_birth:values.date_birth!=''?moment(new Date(values.date_birth)).format('YYYY-MM-DD'):'',
			date_birth_text:values.date_birth_text,
			citizenship:values.citizenship,
			citizen_country:values.citizen_country,
			type_id:values.type_id,
			id_number:values.id_number,
			address1:values.address1,
			address2:values.address2,
			city:values.city,
			state:values.state,
			country:values.country,
			postal_code:values.postal_code,
			primary_number:values.primary_number,
			home_number:values.home_number,
			cellular_number:values.cellular_number,
			fax:values.fax,
			email:values.email,
			marital_status:values.marital_status,
			no_dependents:values.no_dependents,

			joint_first_name:values.joint_first_name,
			joint_middle_name:values.joint_middle_name,
			joint_last_name:values.joint_last_name,
			joint_date_birth_options:values.joint_date_birth_options,
			joint_date_birth:values.joint_date_birth!=''?moment(new Date(values.joint_date_birth)).format('YYYY-MM-DD'):'',
			joint_date_birth_text:values.joint_date_birth_text,
			joint_citizenship:values.joint_citizenship,
			joint_citizen_country:values.joint_citizen_country,
			joint_type_id:values.joint_type_id,
			joint_id_number:values.joint_id_number,
			joint_address1:values.joint_address1,
			joint_address2:values.joint_address2,
			joint_city:values.joint_city,
			joint_state:values.joint_state,
			joint_country:values.joint_country,
			joint_postal_code:values.joint_postal_code,
			joint_primary_number:values.joint_primary_number,
			joint_home_number:values.joint_home_number,
			joint_cellular_number:values.joint_cellular_number,
			joint_fax:values.joint_fax,
			joint_email:values.joint_email,
			joint_marital_status:values.joint_marital_status,
			joint_no_dependents:values.joint_no_dependents,

			years_stock:values.years_stock,
			years_options:values.years_options,
			years_mutual:values.years_mutual,
			years_futures:values.years_futures,
			years_forex:values.years_forex,
			ave_stock:values.ave_stock,
			ave_options:values.ave_options,
			ave_mutual:values.ave_mutual,
			ave_futures:values.ave_futures,
			ave_forex:values.ave_forex,
			rate_stock:values.rate_stock,
			rate_options:values.rate_options,
			rate_mutual:values.rate_mutual,
			rate_futures:values.rate_futures,
			rate_forex:values.rate_forex,
			finance_annual:values.finance_annual,
			finance_marginal:values.finance_marginal,
			finance_totalnet:values.finance_totalnet,
			finance_liquidnet:values.finance_liquidnet,
			finance_sourceincome:values.finance_sourceincome,
			number_contracts:values.number_contracts,
			name_contracts:values.name_contracts,
			finance_amount:values.finance_amount,
			finance_fund:values.finance_fund,
			specify_finance_liquidnet:values.specify_finance_liquidnet,
			specify_finance_totalnet:values.specify_finance_totalnet,
			specify_finance_annual:values.specify_finance_annual

		}


		let formData = new FormData();
		formData.append('type','update_account');
		formData.append('info',JSON.stringify(value));
		axios.post('/client/account/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Data successfully updated."}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Data not successfully saved. Please try again later."}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator."}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}



	/*-------------------------------------
		Querier selection
	--------------------------------------*/
	const [CountriesList, setCountriesList] = useState([]);
	const [SecurityQuestions, setSecurityQuestions] = useState([]);
	const [StocksNumYears, setStocksNumYears] = useState([]);
	const [RateTrading, setRateTrading] = useState([]);
	const [AveTrading, setAveTrading] = useState([]);
	const [AssetsTrading, setAssetsTrading] = useState([]);
	const [ApproxTrading, setApproxTrading] = useState([]);
	const [Approx2Trading, setApprox2Trading] = useState([]);
	const [NestedTrading, setNestedTrading] = useState([]);
	const [SourceTrading, setSourceTrading] = useState([]);
	const [TypeAccount, setTypeAccount] = useState([]);
	const [ListRepresentative, setListRepresentative] = useState([]);


	function SelectionList(){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','query_selection');
		axios.post('/client/account/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				setCountriesList(obj.CountriesList);
				setSecurityQuestions(obj.SecurityQuestions);
				setStocksNumYears(obj.StocksNumYears);
				setRateTrading(obj.RateTrading);
				setAveTrading(obj.AveTrading);
				setAssetsTrading(obj.AssetsTrading);
				setApproxTrading(obj.ApproxTrading);
				setApprox2Trading(obj.Approx2Trading);
				setNestedTrading(obj.NestedTrading);
				setSourceTrading(obj.SourceTrading);
				setTypeAccount(obj.TypeAccount);
				setListRepresentative(obj.ListRepresentative);
				setalert(false);
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


	function AccountDetails(){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','account_details');
		axios.post('/client/account/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj==0){
					WindowLocation('/');
					return false;
				}
				setstate({
					...state,

					reps_id:obj.reps_id!=''?obj.reps_id:'',
					account_type:obj.account_type!=''?obj.account_type:'',

					first_name:obj.first_name!=''?obj.first_name:'',
					middle_name:obj.middle_name!=''?obj.middle_name:'',
					last_name:obj.last_name!=''?obj.last_name:'',
					date_birth_options:obj.date_birth_options!=''?obj.date_birth_options:'1',
					date_birth:obj.date_birth!=''?moment(new Date(obj.date_birth)).format('MM/DD/YYYY'):'',
					date_birth_text:obj.date_birth_text!=''?obj.date_birth_text:'',
					citizenship:obj.citizenship!=''?obj.citizenship:'',
					citizen_country:obj.citizen_country!=''?obj.citizen_country:'',
					type_id:obj.type_id!=''?obj.type_id:'',
					id_number:obj.id_number!=''?obj.id_number:'',
					address1:obj.address1!=''?obj.address1:'',
					address2:obj.address2!=''?obj.address2:'',
					city:obj.city!=''?obj.city:'',
					state:obj.state!=''?obj.state:'',
					country:obj.country!=''?obj.country:'',
					postal_code:obj.postal_code!=''?obj.postal_code:'',
					primary_number:obj.primary_number!=''?obj.primary_number:'',
					home_number:obj.home_number!=''?obj.home_number:'',
					cellular_number:obj.cellular_number!=''?obj.cellular_number:'',
					fax:obj.fax!=''?obj.fax:'',
					email:obj.email!=''?obj.email:'',
					marital_status:obj.marital_status!=''?obj.marital_status:'',
					no_dependents:obj.no_dependents!=''?obj.no_dependents:'',

					joint_first_name:obj.joint_first_name!=''?obj.joint_first_name:'',
					joint_middle_name:obj.joint_middle_name!=''?obj.joint_middle_name:'',
					joint_last_name:obj.joint_last_name!=''?obj.joint_last_name:'',
					joint_date_birth_options:obj.joint_date_birth_options!=''?obj.joint_date_birth_options:'1',
					joint_date_birth:obj.joint_date_birth!=''?moment(new Date(obj.joint_date_birth)).format('MM/DD/YYYY'):'',
					joint_date_birth_text:obj.joint_date_birth_text!=''?obj.joint_date_birth_text:'',
					joint_citizenship:obj.joint_citizenship!=''?obj.joint_citizenship:'',
					joint_citizen_country:obj.joint_citizen_country!=''?obj.joint_citizen_country:'',
					joint_type_id:obj.joint_type_id!=''?obj.joint_type_id:'',
					joint_id_number:obj.joint_id_number!=''?obj.joint_id_number:'',
					joint_address1:obj.joint_address1!=''?obj.joint_address1:'',
					joint_address2:obj.joint_address2!=''?obj.joint_address2:'',
					joint_city:obj.joint_city!=''?obj.joint_city:'',
					joint_state:obj.joint_state!=''?obj.joint_state:'',
					joint_country:obj.joint_country!=''?obj.joint_country:'',
					joint_postal_code:obj.joint_postal_code!=''?obj.joint_postal_code:'',
					joint_primary_number:obj.joint_primary_number!=''?obj.joint_primary_number:'',
					joint_home_number:obj.joint_home_number!=''?obj.joint_home_number:'',
					joint_cellular_number:obj.joint_cellular_number!=''?obj.joint_cellular_number:'',
					joint_fax:obj.joint_fax!=''?obj.joint_fax:'',
					joint_email:obj.joint_email!=''?obj.joint_email:'',
					joint_marital_status:obj.joint_marital_status!=''?obj.joint_marital_status:'',
					joint_no_dependents:obj.joint_no_dependents!=''?obj.joint_no_dependents:'',

					years_stock:obj.years_stock!=''?obj.years_stock:'',
					years_options:obj.years_options!=''?obj.years_options:'',
					years_mutual:obj.years_mutual!=''?obj.years_mutual:'',
					years_futures:obj.years_futures!=''?obj.years_futures:'',
					years_forex:obj.years_forex!=''?obj.years_forex:'',
					ave_stock:obj.ave_stock!=''?obj.ave_stock:'',
					ave_options:obj.ave_options!=''?obj.ave_options:'',
					ave_mutual:obj.ave_mutual!=''?obj.ave_mutual:'',
					ave_futures:obj.ave_futures!=''?obj.ave_futures:'',
					ave_forex:obj.ave_forex!=''?obj.ave_forex:'',
					rate_stock:obj.rate_stock!=''?obj.rate_stock:'',
					rate_options:obj.rate_options!=''?obj.rate_options:'',
					rate_mutual:obj.rate_mutual!=''?obj.rate_mutual:'',
					rate_futures:obj.rate_futures!=''?obj.rate_futures:'',
					rate_forex:obj.rate_forex!=''?obj.rate_forex:'',
					finance_annual:obj.finance_annual!=''?obj.finance_annual:'',
					finance_marginal:obj.finance_marginal!=''?obj.finance_marginal:'',
					finance_totalnet:obj.finance_totalnet!=''?obj.finance_totalnet:'',
					finance_liquidnet:obj.finance_liquidnet!=''?obj.finance_liquidnet:'',
					finance_sourceincome:obj.finance_sourceincome!=''?obj.finance_sourceincome:'',
					number_contracts:obj.number_contracts!=''?obj.number_contracts:'',
					name_contracts:obj.name_contracts!=''?obj.name_contracts:'',
					finance_amount:obj.finance_amount!=''?obj.finance_amount:'',
					finance_fund:obj.finance_fund!=''?obj.finance_fund:'',

					specify_finance_annual:obj.specify_finance_annual!=''?obj.specify_finance_annual:'',
					specify_finance_totalnet:obj.specify_finance_totalnet!=''?obj.specify_finance_totalnet:'',
					specify_finance_liquidnet:obj.specify_finance_liquidnet!=''?obj.specify_finance_liquidnet:'',


				});


		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


	useEffect(()=>{
		SelectionList();
		AccountDetails();
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form>
				 <Formik
					enableReinitialize
					initialValues={state}
					validationSchema={updatevalidations}
					onSubmit={handleSubmitForm}
					render={formProps => {
					const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps

					const CustomDateBirth = ({ value, onClick }) => (
						<Input iconPosition='left' onClick={onClick} value={values.date_birth}><Icon name='calendar alternate' /><input /></Input>
					);
					const CustomDateBirthJoint = ({ value, onClick }) => (
						<Input iconPosition='left' disabled={values.account_type==1} onClick={onClick} value={values.joint_date_birth}><Icon name='calendar alternate' /><input /></Input>
					);


						return(
			         <div className="panel">
							 	  <div className="panel-header">
										<Button className='secondary' icon='save' content='Update' onClick={handleSubmit}/>
									</div>

			            <div className="panel-body hasborderbottom">
									  <div className="panelbody-wrapper50">

											<Form.Group widths="equal">
												<Field name="account_type">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Select type of account</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={TypeAccount}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="reps_id">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Sales Rep</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={ListRepresentative}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
										</div>
									</div>{/*.panel-body*/}


									{/*--------------------------------------------------------
										 Account
										-------------------------------------------------------*/}
									<div className="panel-body hasborderbottom">

									  <div className="panelbody-container">

											 <div>
											 		<div className="panelbodybox">
														<h2>Individual Account Owner</h2>
														<Form.Group widths="equal">
															<Field name="first_name">
																	{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>First Name</label>
																		<Input {...field} onChange={handleChange}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="middle_name">
																	{({ field, form }) => (
																	<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Middle Name</label>
																		<Input {...field} onChange={handleChange}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="last_name">
																	{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Last Name</label>
																		<Input {...field} onChange={handleChange}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="date_birth_options">
																{({ field, form }) => (
																		<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Date of Birth Input Type</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={[
																							{ key: '0', text: 'Dropdown Input', value: '1' },
																							{ key: '1', text: 'Manual Input', value: '2' },
																					]}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>

														{values.date_birth_options==1&&<Form.Group widths="equal">
															<Field name="date_birth">
																	{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Date of Birth</label>
																		<DatePicker
																				showYearDropdown
																				yearDropdownItemNumber={100}
																				scrollableYearDropdown
																				showMonthDropdown
																				dropdownMode="select"
																				maxDate={new Date()}
			                                  selected={values.date_birth!=''?new Date(values.date_birth):null}
			                                  onChange={date => {
			                                     var date_selected 	= moment(new Date(date)).format('MM/DD/YYYY');
																					 setFieldValue(field.name,date_selected);
			                                  }}
			                                  customInput={<CustomDateBirth />}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>}

														{values.date_birth_options==2&&<Form.Group widths="equal">
															<Field name="date_birth_text">
																	{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Date of Birth</label>
																		<Input {...field} onChange={handleChange} placeholder={datenow}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>}

														<Form.Group widths="equal">
															<Field name="citizenship">
																	{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Citizenship</label>
																		<div className="input-chekbox-form">
																			 <span onClick={()=>{setFieldValue('citizenship',1);}}><Icon name={values.citizenship==1?'dot circle outline active':'circle outline'}/>U.K. Citizen</span>
																		</div>
																		<div className="input-chekbox-form">
																			 <span onClick={()=>{setFieldValue('citizenship',2);}}><Icon name={values.citizenship==2?'dot circle outline active':'circle outline'}/>Non - U.K. Citizen</span>
																		</div>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>

														{values.citizenship==2&&<Form.Group widths="equal">
															<Field name="citizen_country">
																	{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Country</label>
																		<Input {...field} onChange={handleChange}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>}


														<Form.Group widths="equal">
															<Field name="type_id">
																{({ field, form }) => (
																		<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Type of ID</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={[
																							{ key: '0', text: 'Drivers License', value: '1' },
																							{ key: '1', text: 'Passport', value: '2' },
																							{ key: '2', text: 'Other government issued ID', value: '3' },
																					]}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="id_number">
																	{({ field, form }) => (
																	<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>ID Number</label>
																		<Input {...field} onChange={handleChange}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
																	)}
															</Field>
														</Form.Group>
													</div>
											 </div>

											 <div>
												 <div className="panelbodybox">
													 <h2 className="jointh2">Joint Account Owner</h2>
													 <div className={values.account_type==1?'joint-wrapper disabled_label':'joint-wrapper'}>
													 <Form.Group widths="equal">
														 <Field name="joint_first_name">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>First Name</label>
																	 <Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														 <Field name="joint_middle_name">
																 {({ field, form }) => (
																 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Middle Name</label>
																	 <Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														 <Field name="joint_last_name">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Last Name</label>
																	 <Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														 <Field name="joint_date_birth_options">
															 {({ field, form }) => (
																	 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		 <label>Date of Birth Input Type</label>
																		 <Select selectOnBlur={false}
																				 {...field}
																				 options={[
																						 { key: '0', text: 'Dropdown Input', value: '1' },
																						 { key: '1', text: 'Manual Input', value: '2' },
																				 ]}
																				 disabled={values.account_type==1}
																				 onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	 </Form.Field>
															 )}
														 </Field>
													 </Form.Group>

													 {values.joint_date_birth_options==1&&<Form.Group widths="equal">
														 <Field name="joint_date_birth">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Date of Birth</label>
																	 <DatePicker
																			 showYearDropdown
																			 yearDropdownItemNumber={100}
																			 scrollableYearDropdown
																			 showMonthDropdown
																			 dropdownMode="select"
																			 maxDate={new Date()}
																			 selected={values.joint_date_birth!=''?new Date(values.joint_date_birth):''}
																			 onChange={date => {
																					var date_selected 	= moment(new Date(date)).format('MM/DD/YYYY');
																					setFieldValue(field.name,date_selected);
																			 }}
																			 disabled={values.account_type==1}
																			 customInput={<CustomDateBirthJoint />}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>}

													 {values.joint_date_birth_options==2&&<Form.Group widths="equal">
														 <Field name="joint_date_birth_text">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Date of Birth</label>
																	 <Input {...field} onChange={handleChange} placeholder={datenow} disabled={values.account_type==1}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>}

													 <Form.Group widths="equal">
														 <Field name="joint_citizenship">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Citizenship</label>
																	 <div className="input-chekbox-form">
																			<span className={values.account_type==1?'disabled_click':''} onClick={()=>{setFieldValue('joint_citizenship',1);}}><Icon name={values.joint_citizenship==1?'dot circle outline active':'circle outline'}/>U.K Citizen</span>
																	 </div>
																	 <div className="input-chekbox-form">
																			<span className={values.account_type==1?'disabled_click':''} onClick={()=>{setFieldValue('joint_citizenship',2);}}><Icon name={values.joint_citizenship==2?'dot circle outline active':'circle outline'}/>Non - U.K. Citizenn</span>
																	 </div>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>

													 {values.joint_citizenship==2&&<Form.Group widths="equal">
														 <Field name="joint_citizen_country">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Country</label>
																	 <Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>}


													 <Form.Group widths="equal">
														 <Field name="joint_type_id">
															 {({ field, form }) => (
																	 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		 <label>Type of ID</label>
																		 <Select selectOnBlur={false}
																				 {...field}
																				 options={[
																						 { key: '0', text: 'Drivers License', value: '1' },
																						 { key: '1', text: 'Passport', value: '2' },
																						 { key: '2', text: 'Other government issued ID', value: '3' },
																				 ]}
																				 disabled={values.account_type==1}
																				 onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	 </Form.Field>
															 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														 <Field name="joint_id_number">
																 {({ field, form }) => (
																 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>ID Number</label>
																	 <Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 </div>
												 </div>
											 </div>

										</div>{/*.panelbody-container*/}
									</div>{/*.panel-body*/}



									{/*--------------------------------------------------------
										 Mailing
										-------------------------------------------------------*/}
									<div className="panel-body hasborderbottom">

									  <div className="panelbody-container">

											 <div>
											 		<div className="panelbodybox">
														<h2>Mailing Address</h2>
														<Form.Group widths="equal">
														 <Field name="address1">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Address 1</label>
																	 <Input {...field} onChange={handleChange}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														<Field name="address2">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Address 2</label>
																	<Input {...field} onChange={handleChange}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
														<Form.Group widths="equal">
														 <Field name="city">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>City</label>
																	 <Input {...field} onChange={handleChange}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														<Field name="state">
																{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>State</label>
																	<Input {...field} onChange={handleChange}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
														<Field name="country">
															{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Country</label>
																		<Select selectOnBlur={false}
																				{...field}
																				options={CountriesList}
																				onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
															)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													 <Field name="postal_code">
															 {({ field, form }) => (
															 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Postal Code</label>
																 <Input {...field} onChange={handleChange}/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
													</div>
											 </div>

											 <div>
												 <div className="panelbodybox">
													 <h2 className="jointh2">Mailing Address</h2>
													 <div className={values.account_type==1?'joint-wrapper disabled_label':'joint-wrapper'}>
													 <Form.Group widths="equal">
														<Field name="joint_address1">
																{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Address 1</label>
																	<Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													 <Field name="joint_address2">
															 {({ field, form }) => (
															 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Address 2</label>
																 <Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
													 <Form.Group widths="equal">
														<Field name="joint_city">
																{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>City</label>
																	<Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													 <Field name="joint_state">
															 {({ field, form }) => (
															 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>State</label>
																 <Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
												 <Form.Group widths="equal">
													 <Field name="joint_country">
														 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Country</label>
																	 <Select selectOnBlur={false}
																			 {...field}
																			 options={CountriesList}
																			 disabled={values.account_type==1}
																			 onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
														 )}
													 </Field>
												 </Form.Group>
												 <Form.Group widths="equal">
													<Field name="joint_postal_code">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Postal Code</label>
																<Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												</div>
												 </div>
											 </div>

										</div>{/*.panelbody-container*/}
									</div>{/*.panel-body*/}


									{/*--------------------------------------------------------
										 Contact Information
										-------------------------------------------------------*/}
									<div className="panel-body hasborderbottom">

									  <div className="panelbody-container">

											 <div>
											 		<div className="panelbodybox">
														<h2>Contact Information</h2>
														<Form.Group widths="equal">
														 <Field name="primary_number">
																 {({ field, form }) => (
																 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <label>Primary/Daytime Phone Number</label>
																	 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 <Form.Group widths="equal">
														<Field name="home_number">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Home/Evening Phone</label>
																	<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													 <Field name="cellular_number">
															 {({ field, form }) => (
															 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Cellular/Portable Phone</label>
																 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
												 <Form.Group widths="equal">
													<Field name="fax">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Fax</label>
																<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
												 <Field name="email">
														 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Email</label>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
													</div>
											 </div>

											 <div>
												 <div className="panelbodybox">
													 <h2 className="jointh2">Contact Information</h2>
													 <div className={values.account_type==1?'joint-wrapper disabled_label':'joint-wrapper'}>
													 <Form.Group widths="equal">
														<Field name="joint_primary_number">
																{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Primary/Daytime Phone Number</label>
																	<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16" disabled={values.account_type==1}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													 <Field name="joint_home_number">
															 {({ field, form }) => (
															 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <label>Home/Evening Phone</label>
																 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16" disabled={values.account_type==1}/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
												 <Form.Group widths="equal">
													<Field name="joint_cellular_number">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Cellular/Portable Phone</label>
																<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16" disabled={values.account_type==1}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
												 <Field name="joint_fax">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <label>Fax</label>
															 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16" disabled={values.account_type==1}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 <Form.Group widths="equal">
												<Field name="joint_email">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>Email</label>
															<Input {...field} onChange={handleChange} disabled={values.account_type==1}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
												 </div>
											 </div>

										</div>{/*.panelbody-container*/}
									</div>{/*.panel-body*/}


									{/*--------------------------------------------------------
										 Filing status
										-------------------------------------------------------*/}
									<div className="panel-body hasborderbottom">

									  <div className="panelbody-container">

											 <div>
											 		<div className="panelbodybox">
														<h2>Filing Status</h2>
														<Form.Group widths="equal">
 	 													<Field name="marital_status">
 	 															{({ field, form }) => (
 	 															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
 																	<div className="input-chekbox-form">
 																		 <span onClick={()=>{setFieldValue('marital_status',1);}}><Icon name={values.marital_status==1?'dot circle outline active':'circle outline'}/>Single</span>
 																	</div>
 																	<div className="input-chekbox-form">
 																		 <span onClick={()=>{setFieldValue('marital_status',2);}}><Icon name={values.marital_status==2?'dot circle outline active':'circle outline'}/>Married</span>
 																	</div>
 	 																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
 	 															</Form.Field>
 	 															)}
 	 													</Field>
 	 												</Form.Group>
 													<Form.Group widths="equal">
  													<Field name="no_dependents">
  															{({ field, form }) => (
  															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
  																<label>No of Dependents</label>
  																<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
  																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
  															</Form.Field>
  															)}
  													</Field>
  												</Form.Group>
													</div>
											 </div>

											 <div>
												 <div className="panelbodybox">
													 <h2 className="jointh2">Filing Status</h2>
													 <div className={values.account_type==1?'joint-wrapper disabled_label':'joint-wrapper'}>
													 <Form.Group widths="equal">
														<Field name="joint_marital_status">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<div className="input-chekbox-form">
																		 <span disabled={values.account_type==1} onClick={()=>{setFieldValue('joint_marital_status',1);}}><Icon name={values.joint_marital_status==1?'dot circle outline active':'circle outline'}/>Single</span>
																	</div>
																	<div className="input-chekbox-form">
																		 <span disabled={values.account_type==1} onClick={()=>{setFieldValue('joint_marital_status',2);}}><Icon name={values.joint_marital_status==2?'dot circle outline active':'circle outline'}/>Married</span>
																	</div>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													<Form.Group widths="equal">
													<Field name="joint_no_dependents">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>No of Dependents</label>
																<Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16" disabled={values.account_type==1}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												</div>
												 </div>
											 </div>

										</div>{/*.panelbody-container*/}
									</div>{/*.panel-body*/}



									{/*--------------------------------------------------------
										 Account bottom
										-------------------------------------------------------*/}
									<div className="panel-body">

									  <div className="panelbody-container">

											 <div>
											 		<div className="panelbodybox">
														<h2>Account Owner</h2>
														<Form.Group widths="equal">
															<Field name="years_stock">
																{({ field, form }) => (
																		<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Stocks</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={StocksNumYears}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="years_options">
																{({ field, form }) => (
																		<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Options</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={StocksNumYears}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="years_mutual">
																{({ field, form }) => (
																		<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Mutual Funds</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={StocksNumYears}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="years_futures">
																{({ field, form }) => (
																		<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Futures</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={StocksNumYears}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="years_forex">
																{({ field, form }) => (
																		<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Forex</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={StocksNumYears}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
													</div>

													<div className="panelbodybox">
														<h2>Average trades executed in a month</h2>
														<Form.Group widths="equal">
															<Field name="ave_stock">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Stocks</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={AveTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="ave_options">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Options</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={AveTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="ave_mutual">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Mutual Funds</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={AveTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="ave_futures">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Futures</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={AveTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="ave_forex">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Forex</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={AveTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
													</div>

													<div className="panelbodybox">
														<h2>Rate your trading knowledge</h2>
														<Form.Group widths="equal">
															<Field name="rate_stock">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Stocks</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={RateTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="rate_options">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Options</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={RateTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="rate_mutual">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Mutual Funds</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={RateTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="rate_futures">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Futures</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={RateTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
														<Form.Group widths="equal">
															<Field name="rate_forex">
																{({ field, form }) => (
																		<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																			<label>Forex</label>
																			<Select selectOnBlur={false}
																					{...field}
																					options={RateTrading}
																					onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																			{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																		</Form.Field>
																)}
															</Field>
														</Form.Group>
													</div>


											 </div>





											 <div>
												 <div className="panelbodybox">
													 <h2>Financial Information</h2>

													 <Form.Group widths="equal">
		 												<Field name="finance_annual">
		 													{({ field, form }) => (
		 															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 																<label>Approximate Annual Income</label>
		 																<Select selectOnBlur={false}
		 																		{...field}
		 																		options={ApproxTrading}
		 																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
		 																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 															</Form.Field>
		 													)}
		 												</Field>
		 											</Form.Group>

													{/*values.finance_annual==1&&<Form.Group widths="equal">
		 		                    <Field name="specify_finance_annual">
		 		                        {({ field, form }) => (
		 		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 															<label className="labelred">Specify Annual Income</label>
		 		                          <Input {...field} onChange={handleChange}/>
		 		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 		                        </Form.Field>
		 		                        )}
		 		                    </Field>
		 		                  </Form.Group>*/}

		 											<Form.Group widths="equal">
		 												<Field name="finance_marginal">
		 													{({ field, form }) => (
		 															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 																<label>Nested Marginal Bracket</label>
		 																<Select selectOnBlur={false}
		 																		{...field}
		 																		options={NestedTrading}
		 																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
		 																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 															</Form.Field>
		 													)}
		 												</Field>
		 											</Form.Group>


		 											<Form.Group widths="equal">
		 												<Field name="finance_totalnet">
		 													{({ field, form }) => (
		 															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 																<label>Approximate Total Networth</label>
		 																<Select selectOnBlur={false}
		 																		{...field}
		 																		options={Approx2Trading}
		 																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
		 																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 															</Form.Field>
		 													)}
		 												</Field>
		 											</Form.Group>

													{/*values.finance_totalnet==1&&<Form.Group widths="equal">
		 		                    <Field name="specify_finance_totalnet">
		 		                        {({ field, form }) => (
		 		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 															<label className="labelred">Specify Total Net Worth</label>
		 		                          <Input {...field} onChange={handleChange}/>
		 		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 		                        </Form.Field>
		 		                        )}
		 		                    </Field>
		 		                  </Form.Group>*/}

		 											<Message warning visible>Total Net Worth equals all investments, current, savings, properties holdings and other assets, minus all obligations, debts and liabilities excluding assets and liabilities relating to family residence.</Message>

		 											<Form.Group widths="equal">
		 												<Field name="finance_liquidnet">
		 													{({ field, form }) => (
		 															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 																<label>Approximate Liquid Networth</label>
		 																<Select selectOnBlur={false}
		 																		{...field}
		 																		options={Approx2Trading}
		 																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
		 																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 															</Form.Field>
		 													)}
		 												</Field>
		 											</Form.Group>

													{/*values.finance_liquidnet==1&&<Form.Group widths="equal">
		 		                    <Field name="specify_finance_liquidnet">
		 		                        {({ field, form }) => (
		 		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 															<label className="labelred">Specify Liquid Net Worth</label>
		 		                          <Input {...field} onChange={handleChange}/>
		 		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 		                        </Form.Field>
		 		                        )}
		 		                    </Field>
		 		                  </Form.Group>*/}

		 											<Message warning visible>Liquid Net Worth includes cash and marketable securities, minus all obligation, debts and liabilities.</Message>

		 											<Form.Group widths="equal">
		 												<Field name="finance_sourceincome">
		 													{({ field, form }) => (
		 															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 																<label>What is your source of income?</label>
		 																<Select selectOnBlur={false}
		 																		{...field}
		 																		options={SourceTrading}
		 																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
		 																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 															</Form.Field>
		 													)}
		 												</Field>
		 											</Form.Group>

		 											<div className="labelform">Contract Applied For:</div>
		 											<Form.Group widths="equal">
		 		                    <Field name="number_contracts">
		 		                        {({ field, form }) => (
		 		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 															<label>Enter the number of Contract (s)</label>
		 		                          <Input {...field} onChange={handleChange}/>
		 		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 		                        </Form.Field>
		 		                        )}
		 		                    </Field>
		 		                  </Form.Group>
		 											<Form.Group widths="equal">
		 		                    <Field name="name_contracts">
		 		                        {({ field, form }) => (
		 		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 															<label>Enter the name of Contract (s)</label>
		 		                          <Input {...field} onChange={handleChange}/>
		 		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 		                        </Form.Field>
		 		                        )}
		 		                    </Field>
		 		                  </Form.Group>

		 											<div className="labelform">APPLICATION MONIES:</div>
		 											<Form.Group widths="equal">
		 		                    <Field name="finance_amount">
		 		                        {({ field, form }) => (
		 		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
		 															<label>Enter the application amount</label>
		 		                          <Input {...field} onChange={handleChange}/>
		 		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		 		                        </Form.Field>
		 		                        )}
		 		                    </Field>
		 		                  </Form.Group>

													<Message warning visible>How will you fund your account?</Message>

													<Form.Group widths="equal">
														<Field name="finance_fund">
															{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<label>Source of assets to be deposited</label>
																		<Select selectOnBlur={false}
																				{...field}
																				options={AssetsTrading}
																				onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
															)}
														</Field>
													</Form.Group>

												 </div>
											 </div>



										</div>{/*.panelbody-container*/}
									</div>{/*.panel-body*/}



			            <div className="panel-footer">
										<Button className='secondary' icon='save' content='Update' onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>

      </div>
    </React.Fragment>
  )
}
